export function insertAfter(el, referenceNode) {
  referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

/*!
 * JavaScript detach - v0.2 - 5/18/2011
 * http://benalman.com/
 *
 * Copyright (c) 2011 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

export function detach(node, asnc, fn) {
  let callback = fn;
  let async = asnc;

  const parent = node.parentNode;
  const next = node.nextSibling;

  // Re-attach node to DOM.
  const reattach = () => {
    parent.insertBefore(node, next);
  };

  // No parent node? Abort!
  if (!parent) { return; }

  // Detach node from DOM.
  parent.removeChild(node);

  // Handle case where optional `async` argument is omitted.
  if (typeof async !== 'boolean') {
    callback = async;
    async = false;
  }

  // Note that if a function wasn't passed, the node won't be re-attached!
  if (callback && async) {
    // If async == true, reattach must be called manually.
    callback.call(node, reattach);
  } else if (callback) {
    // If async != true, reattach will happen automatically.
    callback.call(node);
    reattach();
  }
}

export function outerHeight(el) {
  let height = el.offsetHeight;
  const style = getComputedStyle(el);

  height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);

  return height;
}

export function css(elem, prop, value) {
  if (!value) {
    const b = (window.navigator.userAgent).toLowerCase();
    let s;

    if (/msie|opera/.test(b)) {
      s = elem.currentStyle;
    } else if (/gecko/.test(b)) {
      s = document.defaultView.getComputedStyle(elem, null);
    }

    if (s[prop] !== undefined) {
      return s[prop];
    }

    return elem.style[prop];
  }

  if (prop) {
    elem.style[prop] = value;
  }

  return true;
}
